import { render, staticRenderFns } from "./FocusCard.vue?vue&type=template&id=4e9f973a&scoped=true"
import script from "./FocusCard.vue?vue&type=script&lang=js"
export * from "./FocusCard.vue?vue&type=script&lang=js"
import style0 from "./FocusCard.vue?vue&type=style&index=0&id=4e9f973a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9f973a",
  null
  
)

export default component.exports